import { c as _c } from "react/compiler-runtime";
import { BuildersListSkeleton } from './components/builders-list/builders-list-skeleton';
import { BuildersTableSkeleton } from './components/builders-table/builders-table-skeleton';
function BuildersSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><BuildersTableSkeleton className="hidden lg:flex" /><BuildersListSkeleton className="flex lg:hidden" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export { BuildersSkeleton };